import { W as WuiMoreMenu$1, d as defineCustomElement$1 } from './p-HvJU2bIh.js';

const WuiMoreMenu = WuiMoreMenu$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMoreMenu, defineCustomElement };
